export default "__VITE_ASSET__0495bfd7__"